import { Button, Drawer, FormControl, IconButton, Stack, TextField,InputAdornment,Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from "@mui/icons-material/Close";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import DelimiterDialog from '../../../TemplateProperties/DelimiterDialog';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { CircularProgress,Box } from '@mui/material';
import LightTooltip from '../../../../commonComponents/LightTooltip';

const QuickAddFromFile = ({ open, setOpenFileModal,setData,delimiter,onDelimiterChange}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [fieldDelimiter, setFieldDelimiter] = useState(false);
    const [fieldDelimiterValue, setFieldDelimiterValue] = useState(',');
    const [recordDelimiter, setRecordDelimiter] = useState(false);
    const [recordDelimiterValue, setRecordDelimiterValue] = useState('CRLF');
    const [filePath, setFilePath] = useState('');
    const [enable, setEnable] = useState(true);
    const [file, setFile] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [errorMessage,setErrorMessage] = useState('')
    const fileBrowser = useRef();
    const handleFieldDelimitedInput = (val) => {
        setFieldDelimiterValue(val);
    }
    const handleRecordDelimitedInput = (val) => {
      let newDelimiter;
      if (val === "CRLF") {
        newDelimiter = "\\r\\n";
      } else {
        newDelimiter = val;
      }
      onDelimiterChange(newDelimiter);
      setRecordDelimiterValue(val);
    };
    
    const handleUploadFile = (e) => {
      const file = e.target.files[0];
      const fileExtension = file.name.split(".").pop();
      setFilePath(file.name);                                 
      setFile(file);
      if (["doc", "docx", "xls", "xlsx"].includes(fileExtension)) {
        setErrorMessage(t("FILE_ERR_MSG"));
        setEnable(true)
      } else {
        setEnable(false);
        setErrorMessage("");
      }
    };
    const removeASCII = (input) => {
      if(input === t('TXT_NO_DELIM_CHOSEN')) return'';
      let output;
      const regex = /ASCII (\d+) \(([^)]+)\)/;
      if (input === "CRLF") output = "\\r\\n";
      else {
        output = input.replace(regex, "$2");
      }
      return output;
    };
    const addItems = () => {
        if (file) {
            setIsLoading(true)
            const formData = new FormData();
            formData.append('file', file);
            const record_delim = removeASCII(recordDelimiterValue) === '\r\n' ? removeASCII(recordDelimiterValue) : encodeURIComponent(removeASCII(recordDelimiterValue))
            dispatch(api.endpoints.addDataFromFile.initiate({
                data: formData,
                field_delimiter:encodeURIComponent(removeASCII(fieldDelimiterValue)),
                record_delimiter: record_delim
            })
            ).then((res) => {
                if (res.data.current_state === 'SUCCESS') {
                  setIsLoading(false);

                    const mapName = res?.data?.data?.Field_Name;
                    const fieldType = res?.data?.data?.Field_Type
                    setData(mapName)
                    setOpenFileModal(false)
                }
                else {
                  setIsLoading(false)
                  setErrorMessage(res?.data?.message)
                }
            })
            setEnable(false);
        } else {
            setEnable(true);
        }
    }
   const delimDisplay = (val)=>{
    if(val === undefined) return '';
    if (typeof val === 'boolean'|| val === t('TXT_NO_DELIM_CHOSEN') || !val) return t('TXT_NO_DELIM_CHOSEN');
    if (val === "CR" || val === "%0D" || val === "\r") return "CR";
    if (val === "LF" || val === "%0A" | val === "\n" ) return "LF";
    if (val === "CRLF" || val === "%0D%0A") return "CRLF";
    try { val = decodeURIComponent(val) } 
    catch (e) { 
      //case - malformed URI
      //console.log(`delimDisplay - URI malformed, can not decode - ${props.label} '${val}' - Displaying raw.`) 
    }
    return val.length < 3 ?
      val.split('').map(e => `ASCII ${e.charCodeAt(0)} (${e})`).join('')
      : val;
  }
  const setDelimiters = (field, record) => {
    setFieldDelimiterValue(field ? delimDisplay(field) : delimDisplay(null));
    setRecordDelimiterValue(record ? delimDisplay(record) : delimDisplay(null));
  };
  useEffect(() => {
    setDelimiters(fieldDelimiterValue, recordDelimiterValue);
  }, [fieldDelimiterValue, recordDelimiterValue]);
  
  const drawerWidth = 450;
  const handleBackdropClick = (event,reason) => {
    // Prevent closing the drawer when the backdrop is clicked
    if(reason =='backdropClick') return;
  };
   
   return (
     <>
       <Drawer
         anchor="left"
         open={open}
         onClose={() => setOpenFileModal(false)}
         ModalProps={{
          onClose: handleBackdropClick,
        }}
         SlideProps={{
           style: { transform: open ? "translateX(0)" : "translateX(-240px)" },
         }}
         sx={{
           width: drawerWidth,
           flexShrink: 0,
           "& .MuiDrawer-paper": {
             width: drawerWidth,
             boxSizing: "border-box",
             boxShadow:'none'
           },
         }}>
         <div style={{ borderRight: "solid 1px #e0e0e0", height: "100%" }}>
           <div
             className="flex-column height-100"
             style={{ backgroundColor: "#fff", position: "relative" }}>
             <div className="quick-add-container padding-16">
               <div style={{ lineHeight: "25px" }}>
                 <p style={{ marginBottom: "10px" }}>
                   {t("DIAG_QUICK_FIELD_ADD_FROM_FILE_TIT")}
                 </p>
                 <div className="font-12">
                   <p>{t("DIAG_QUICK_FIELD_ADD_FROM_FILE_DESC")}</p>
                 </div>
               </div>
             </div>
             <div
               style={{
                 padding: "16px",
               }}>
               <Stack sx={{ margin: "8px" }}>
                 <div className="flex width-100">
                   <TextField
                     variant="outlined"
                     size="small"
                     autoComplete="off"
                     label={t("LBL_CHOOSE_FILE")}
                     className={"width-100"}
                     name={"FILE_PATH"}
                     value={filePath || ""}
                   />
                   <input
                     style={{ display: "none" }}
                     type="file"
                     ref={fileBrowser}
                     onChange={(e) => {
                       handleUploadFile(e);
                     }}
                   />
                   <Button
                     variant="outlined"
                     size="small"
                     disableElevation
                     className="margin-left-4"
                     sx={{
                       width: "40px",
                       padding: "4px 8px",
                       minWidth: "40px",
                     }}
                     onClick={() => {
                       fileBrowser.current.click();
                     }}>
                     <DriveFolderUploadIcon fontSize="small" />
                   </Button>
                 </div>
                 <FormControl className="width-100 margin-top-16" size="small">
                   <TextField
                     variant="outlined"
                     size="small"
                     autoComplete="off"
                     type="text"
                     value={fieldDelimiterValue}
                     className={"width-100"}
                     label={t("FIELD_DELIMITER")}
                     name={"FIELD_DELIMITER"}
                     InputProps={{
                      readOnly: true,
                      endAdornment: (
                      <InputAdornment position="end">
                        <LightTooltip
                          className="margin-left-4" 
                          title={t('CASCHE_EDIT')}
                          placement={"right-start"}
                        >
                          <Button 
                            size='small'
                            sx={{
                              width: '100% !important', 
                              minWidth: '100% !important',
                            }}>
                            <BorderColorIcon fontSize='medium'/>
                          </Button>
                        </LightTooltip>
                      </InputAdornment>)
                    }}
                     onClick={() =>{
                      setErrorMessage('')
                      setFieldDelimiter(true)
                     }
                    }
                   />
                 </FormControl>
                 <FormControl className="width-100  margin-top-16" size="small">
                   <TextField
                     variant="outlined"
                     size="small"
                     autoComplete="off"
                     type="text"
                     value={recordDelimiterValue}
                     className={"width-100"}
                     label={t("RECORD_DELIMITER")}
                     name={"RECORD_DELIMITER"}
                     InputProps={{
                      readOnly: true,
                      endAdornment: (
                      <InputAdornment position="end">
                        <LightTooltip
                          className="margin-left-4" 
                          title={t('CASCHE_EDIT')}
                          placement={"right-start"}
                        >
                          <Button 
                            size='small'
                            sx={{
                              width: '100% !important', 
                              minWidth: '100% !important',
                            }}>
                            <BorderColorIcon fontSize='medium'/>
                          </Button>
                        </LightTooltip>
                      </InputAdornment>)
                    }}
                     onClick={() =>{
                      setErrorMessage('')
                      setRecordDelimiter(true)
                     }
                    }
                   />
                 </FormControl>
                 <div className="margin-top-16">
                  <Button
                    size='small'
                    variant="outlined"
                    color="primary"
                    disabled={enable}
                    onClick={addItems}
                  >
                    {t("MNU_ADD_ITEMS")}
                  </Button>
                  <Button
                    size='small'
                    className="margin-left-4"
                    variant="outlined"
                    color="primary"
                    onClick={() => setOpenFileModal(false)}>
                    {t("CANCEL")}
                  </Button>
                 </div>
                 <div style={{ paddingTop: "10px" }}>
                   <p className="error">{errorMessage}</p>
                 </div>
               </Stack>
             </div>
             {isLoading ? (
               <Box
                 sx={{
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                   minHeight: "25px",
                 }}>
                 <CircularProgress />
               </Box>
             ) : (
               ""
             )}
           </div>
         </div>
       </Drawer>
       <DelimiterDialog
         modalOpen={fieldDelimiter}
         close={() => setFieldDelimiter(false)}
         from={"returnValueDialog"}
         handleInput={handleFieldDelimitedInput}
         val={fieldDelimiterValue}
         name={"FIELD_DELIMITER"}
         className={"value-editor-delimeter-div"}
       />
       <DelimiterDialog
         modalOpen={recordDelimiter}
         close={() => setRecordDelimiter(false)}
         from={"returnValueDialog"}
         handleInput={handleRecordDelimitedInput}
         val={recordDelimiterValue}
         name={"RECORD_DELIMITER"}
         className={"value-editor-delimeter-div"}
       />
     </>
   );
}
export default QuickAddFromFile